export * from '@yandex-int/hr-components/Link/desktop/bundle';
